<template>
  <div class="applications">
    <b-row class="m-3 row-line">
      <b-col class="text-center menu-app-button" @click="clickRH">
        <i class="fa fa-users icon-application"></i>
        <h4 class>Recursos Humanos</h4>
      </b-col>
      <b-col v-if="accessBi" class="text-center menu-app-button" @click="clickBI">
        <i class="fa fa-line-chart icon-application"></i>
        <h4 class>BI</h4>
      </b-col>
      <b-col class="text-center menu-app-button" @click="clickGlpi">
        <i class="fa fa-line-chart icon-application"></i>
        <h4 class>GLPI Fila Geral</h4>
      </b-col>
      <b-col class="text-center menu-app-button" @click="clickCedoc">
        <i class="fa fa-video-camera icon-application"></i>
        <h4 class>CEDOC</h4>
      </b-col>
      <b-col class="text-center menu-app-button" @click="clickChurchs">
        <i class="fa fa-book icon-application"></i>
        <h4 class>Bíblia online</h4>
      </b-col>
    </b-row>
  </div>
</template>

<script>
//variaveis globais
import { baseApiUrl, baseApiUrlRH } from "@/global";
//cliente http
import axios from "axios";

export default {
  name: "Applications",
  data() {
    return {
      userContext: this.$store.state.userContext,
      accessBi: false,
      accessRh: false,
    };
  },
  methods: {
    async accessBiService() {
      let data = await axios
        .get(`${baseApiUrl}/bi/listScreen/${this.userContext.userId}`)
        .then((resp) => resp.data);
      this.accessBi = data.length > 0 ? true : false;
    },
    async verifyIfPersonIsRH() {
      this.accessRh = await axios
        .get(`${baseApiUrlRH}rh/verifyIfPersonIsRH/${this.userContext.userId}`)
        .then((resp) => resp.data);
    },

    clickStock() {
      this.$router.push({ name: "stock" });
    },
    clickRH() {
      this.$router.push({ name: "rh" });
    },
    clickBI() {
      this.$router.push({ name: "bi" });
    },
    clickGlpi() {
      this.$router.push({ name: "glpi" });
    },
    clickCedoc() {
      this.$router.push({ name: "cedoc" });
    },
    clickChurchs() {
      this.$router.push({ name: "churchs" });
    },
  },
  mounted() {
    this.accessBiService();
    this.verifyIfPersonIsRH();
  },
};
</script>

<style>
.applications {
  margin-top: 70px;
}

.menu-app-button {
  height: 118px;
  max-width: 450px;
  margin-right: 8px;
  margin-bottom: 6px;
  width: 80px;
  border: 1px solid;
  background: #ddeef5;
  color: #2d62a4;
  cursor: pointer;
  box-shadow: 0 9px 9px 0 rgba(0, 0, 0, 0.397), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.menu-app-button > h4 {
  font-size: 28px;
}

.menu-app-button:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
  transition: 1s ease;
}

.menu-app-button > .icon-application {
  font-size: 40px;
  margin-top: 9px;
  margin-bottom: 8px;
}

/* área responsiva */
@media screen and (max-width: 600px) {
  .row-line {
    display: block;
  }

  .menu-app-button {
    width: 100%;
  }
}
</style>
